import React from 'react';
import PropTypes from 'prop-types';
import { FDBodyText } from '@facet-wealth/design';


const WizardFooterText = ({
  value,
}) => {
  if (Array.isArray(value)) {
    return value.map(text => (
      <FDBodyText
        size="sm"
        value={text}
        align={'center'}
      />
    ));
  }
  return <FDBodyText size="sm" value={value} align={'center'} />;
};

WizardFooterText.defaultProps = {
};

WizardFooterText.propTypes = {
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string),
  ]).isRequired,
};

export default WizardFooterText;
